(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('hp-save-to-build')) return;
  var decimalId = /^[1-9][0-9]{0,29}$/;

  function accountDestination(value) {
    var destination = new URL(value);
    if (destination.protocol !== 'https:' || destination.username || destination.password) throw new Error('Invalid account page');
    // Never carry preview tokens, customer identifiers, or other copied query data.
    destination.search = '';
    destination.hash = '';
    return destination;
  }

  class SaveToBuild extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      var root = this;
      var form = root.closest('form');
      var button = root.querySelector('[data-save-to-build-button]');
      var error = root.querySelector('[data-save-to-build-error]');
      var variants;
      var accountUrl;
      try {
        accountUrl = accountDestination(root.dataset.accountUrl).toString();
        variants = JSON.parse(root.querySelector('[data-save-to-build-variants]').textContent);
        if (!form || !button || !error || !decimalId.test(root.dataset.productId) || !Array.isArray(variants) || !variants.length) return;
        if (variants.some(function (variant) { return !decimalId.test(variant.id) || !Array.isArray(variant.options); })) return;
      } catch (ignored) { return; }
      this.ready = true;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        error.hidden = true;
        try {
          // Read the live field in this exact form on every click, never the URL or initial variant.
          var controls = Array.from(form.querySelectorAll('input[name="id"], select[name="id"]')).filter(function (control) {
            return !control.disabled && (control.type !== 'radio' || control.checked);
          });
          var ids = Array.from(new Set(controls.map(function (control) { return String(control.value || '').trim(); })));
          var variant = ids.length === 1 && variants.find(function (item) { return item.id === ids[0]; });
          if (!variant) throw new Error('Choose a product option before saving it to your build.');

          // If a swatch changed before the theme updated its hidden ID, fail instead of saving the old option.
          var optionControls = Array.from(form.querySelectorAll('input[data-option-position], select[data-option-position]')).filter(function (control) {
            return !control.disabled && (control.type !== 'radio' || control.checked);
          });
          if (optionControls.some(function (control) {
            var position = Number(control.dataset.optionPosition);
            return !Number.isInteger(position) || position < 1 || variant.options[position - 1] !== control.value;
          })) throw new Error('Your product option is updating. Please try Save to build again.');

          var destination = accountDestination(accountUrl);
          destination.searchParams.set('product', root.dataset.productId);
          destination.searchParams.set('variant', variant.id);
          window.location.assign(destination.toString());
        } catch (failure) {
          error.textContent = failure.message === 'Choose a product option before saving it to your build.' || failure.message === 'Your product option is updating. Please try Save to build again.'
            ? failure.message : 'Your garage could not be opened. Please try again.';
          error.hidden = false;
        }
      });
      root.hidden = false;
    }
  }
  window.customElements.define('hp-save-to-build', SaveToBuild);
})();
